import React from "react";
import { Props } from "./types";
import { ElementContext, useElementContext } from "./context";

function Context({ minDate, maxDate, children }: Props) {
  const [dragState, setDragState] = React.useState({
    isPressing: false,
    isDragging: false,
    offset: 0,
    clickInitialPos: 0,
  });
  const [leftResizeState, setLeftResizeState] = React.useState({
    isResizing: false,
    offset: 0,
  });
  const [rightResizeState, setRightResizeState] = React.useState({
    isResizing: false,
    offset: 0,
  });

  return (
    <ElementContext.Provider
      value={{
        state: {
          minDate,
          maxDate,
          resize: {
            left: leftResizeState,
            right: rightResizeState,
          },
          drag: dragState,
        },
        reducer: {
          resize(nextState, side) {
            side === "left"
              ? setLeftResizeState((state) => nextState(state))
              : setRightResizeState((state) => nextState(state));
          },
          drag(nextState) {
            setDragState((state) => nextState(state));
          },
        },
      }}
    >
      {children}
    </ElementContext.Provider>
  );
}

export { Context, useElementContext };
